import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbStepperComponent, MdbStepperModule } from 'mdb-angular-ui-kit/stepper';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-cambia-password-utente',
  standalone: true,
  templateUrl: './cambia-password-utente.component.html',
  styleUrls: ['./cambia-password-utente.component.scss'],
  imports: [MdbStepperModule, RouterModule, ReactiveFormsModule,
    MdbFormsModule
  ]
})
export class CambiaPasswordUtenteComponent implements OnInit {

  formEmail: FormGroup;
  formCodice: FormGroup;
  formPassword: FormGroup;
  e = ''
  codiceInviato: string = ''

  @ViewChild('stepper') stepper!: MdbStepperComponent;

  constructor(private service: UtenteService) {
    this.formEmail = new FormGroup({
      email: new FormControl('', [Validators.required]),
    });
    this.formPassword = new FormGroup({
      password: new FormControl('', [Validators.required]),
      conferma: new FormControl('', [Validators.required]),
    });
    this.formCodice = new FormGroup({
      codice: new FormControl('', [Validators.required]),
    });
  }
  get email() { return this.formEmail.get('email') as FormControl }
  get codice() { return this.formCodice.get('codice') as FormControl }
  get password() { return this.formPassword.get('password') as FormControl }
  get conferma() { return this.formPassword.get('conferma') as FormControl }

  ngOnInit(): void {
    this.service.isLogin.subscribe(
      (utente) => {
        if (utente as Utente) {
          this.e = this.service.getUtente().getEmail()
          this.email.patchValue(this.e)
          this.formEmail.markAllAsTouched()
        }
      }
    )
  }

  sendCode() {
    this.service.sendCode(this.email.value).subscribe(
      (ut: any) => {
        console.log(ut)
        if (ut['res'] == 'ko') {
          alert('Errore nell\'invio del codice. Riprova più tardi')
        } else {
          this.codiceInviato = ut['codice']
          this.stepper.next()
        }
      }
    )
  }

  verificaCodice() {
    if (this.codice.value == this.codiceInviato) {
      this.stepper.next()
    } else {
      alert('Codice errato')
    }
  }

  cambiaPassword() {
    if (this.password.value != this.conferma.value) {
      alert('Le password non coincidono')
      return
    }
    this.service.cambiaPassword(this.email.value, this.password.value).subscribe(
      (ut: any) => {
        if (ut['res'] == 'ko') {
          alert('errore')
        } else {
          this.stepper.next()
        }
      }
    )
  }
}
